"use client";

import Image from "next/image";

import { useLpvConfig } from "@/lib/lpv/lpv.context";

type Props = {
  src?: string;
  alt: string;
};

export function HeroImage({ src, alt }: Props) {
  const { showHero } = useLpvConfig();
  if (!showHero) return null;

  return (
    <div className="relative h-60 w-full mb-4 sm:mb-6 lg:my-6 overflow-hidden rounded-none lg:rounded-[10px]">
      {src ? (
        <Image
          src={src}
          alt={alt}
          fill
          sizes="100vw"
          className="object-cover"
        />
      ) : (
        <div
          className="h-full w-full bg-surface-grayscale-subtle"
          aria-hidden
        />
      )}
    </div>
  );
}
